import { IconButton } from '@mui/material';
import { useCallback } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { UseTableCellProps } from 'react-table';
import { AdditionalQuoteDocumentationItem } from 'shared/types/quoteReview';
import { QuoteDoc } from 'shared/types/quotes';
import DeleteIcon from '@mui/icons-material/Delete';

export function QuoteFileDeleteColumn(props: UseTableCellProps<AdditionalQuoteDocumentationItem>) {
  const { setValue } = useFormContext();
  const currentQuoteFiles = useWatch({ name: 'quoteDocumentation' }) as QuoteDoc[];
  const currentQuoteFilesToDelete = useWatch({ name: 'quoteFilesToDelete' }) as QuoteDoc[];

  const handleDelete = useCallback(
    (id: string) => {
      const fileToDelete = currentQuoteFiles.find(q => q.id === id);
      currentQuoteFilesToDelete.push(fileToDelete!);
      setValue('quoteFilesToDelete', currentQuoteFilesToDelete);
    },
    [currentQuoteFiles, currentQuoteFilesToDelete, setValue]
  );

  const { value } = props;
  return (
    <IconButton
      color='primary'
      aria-label='delete file'
      title='Delete File'
      onClick={() => {
        handleDelete(value);
      }}
    >
      <DeleteIcon />
    </IconButton>
  );
}
